// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ln-3";
export var downloadButton = "_ln-4";
export var fileContainer = "_ln-9 _ln-7";
export var fileContainerBase = "_ln-7";
export var fileContainerFixedHeight = "_ln-8 _ln-7";
export var fileInfo = "_ln-5";
export var fileInfoWidthRestricted = "_ln-6";
export var fileType = "_ln-1";
export var fileTypeName = "_ln-2";
export var image = "_ln-0";
export var link = "_ln-b";
export var overflowEllipsis = "_ln-a";